<form (ngSubmit)="form.valid && submit()" #form="ngForm" novalidate>
  <div class="modal-body">
    <div>
      <button type="button" class="close" (click)="close()">&times;</button>
    </div>

    <!-- Status Dropdown -->
    <div class="form-group text-start mb-3" *ngIf="user.status !== 12">
      <label for="status">Status:<span style="color: red;">*</span></label>
      <select id="status" class="form-control" name="status" (change)="changeDrop($event)" [(ngModel)]="user.status"
        #statusField="ngModel" required>
        <option value="">--select--</option>
        <ng-container *ngFor="let objc of statusValues">
          <option [value]="objc.value">{{ objc.name }}</option>
        </ng-container>
      </select>
      <div class="text-danger" *ngIf="statusField.invalid && statusField.touched">
        Status is required.
      </div>
    </div>

    <!-- Opportunity Status -->
    <div class="form-group text-start mb-3" *ngIf="user.status == 9 || user.status == 12">
      <label for="opportunityStatus">Opportunity Status:<span style="color: red;">*</span></label>
      <select id="opportunityStatus" class="form-control" name="opportunityStatus" [(ngModel)]="user.opportunityStatus"
        #oppStatusField="ngModel" required>
        <option value="0">--Oppurtunity Status--</option>
        <ng-container *ngFor="let objc of oppStatusValues">
          <option [value]="objc.value">{{ objc.name }}</option>
        </ng-container>
      </select>
      <div class="text-danger" *ngIf="oppStatusField.invalid && oppStatusField.touched">
        Opportunity status is required.
      </div>
    </div>

    <!-- Remarks -->
    <div class="form-group text-start mb-3">
      <label for="remarks">Remarks:<span style="color: red;">*</span></label>
      <textarea id="remarks" class="form-control" name="remarks" [(ngModel)]="user.remarks" #remarksField="ngModel"
        required></textarea>
      <div class="text-danger" *ngIf="remarksField.invalid && remarksField.touched">
        Remarks are required.
      </div>
    </div>

    <!-- Actual Product Cost -->
    <div class="form-group text-start mb-3" *ngIf="user.status === 12">
      <label for="actualProductCost">Actual Product Cost:<span style="color: red;">*</span></label>
      <input id="actualProductCost" class="form-control" name="actualProductCost" [(ngModel)]="user.actualProductCost"
        #costField="ngModel" type="text" pattern="^[0-9]+(\.[0-9]{1,2})?$" required />
      <div class="text-danger" *ngIf="costField.invalid && costField.touched">
        Enter a valid product cost.
      </div>
    </div>

    <!-- Date Picker: only visible for Followup -->
    <div class="form-group text-start mb-3" *ngIf="user.status === 5 || user.status === 9">
      <label for="date">Date:<span style="color: red;">*</span></label>
      <input type="datetime-local" id="date" class="form-control" name="date" [(ngModel)]="user.date"
        [min]="minDateTime" #dateField="ngModel" required />

      <div class="text-danger" *ngIf="dateField.invalid && dateField.touched">
        Date is required for follow-up.
      </div>
    </div>

    <!-- Submit Button -->
    <button class="btn btn-primary custom-button" type="submit" [disabled]="form.invalid || (user.status == 9 && (!user.opportunityStatus || user.opportunityStatus == 0)) || (user.status == 12 && (!user.actualProductCost || user.actualProductCost == ''))">
      Submit
    </button>
  </div>
</form>